import React from 'react';

import { DocumentPanelPrimary } from '../../components/DocumentPanel';
import ClinicalDocumentLayout, {
  ClinicalDocumentProps,
} from '../ClinicalDocumentLayout';
import SignaturePractitioner from '../SignaturePractitioner';

type Props = ClinicalDocumentProps<fhir4.CarePlan>;

const DocumentPageOrientacao: React.FC<Props> = ({
  resource,
  encounter,
  photo,
  header,
}) => {
  const { title = 'Orientação', text: { div } = {}, description } = resource;

  return (
    <ClinicalDocumentLayout
      title="Orientações para o paciente"
      photo={photo}
      header={header}
      encounter={encounter}
      footer={
        <SignaturePractitioner
          encounter={encounter}
          style={{ alignSelf: 'center' }}
        />
      }
    >
      <DocumentPanelPrimary wrap title={title} content={div || description} />
    </ClinicalDocumentLayout>
  );
};

export default DocumentPageOrientacao;
